<!--
 * @Author: 仙道
 * @Date: 2022-08-22 22:19:15
 * @LastEditTime: 2022-12-06 13:33:08
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/video/modules/player.vue
-->
<template>
  <div @dblclick="fullscreen" ref="container" style="width:100%;height:100%;background-color: #000000;margin:0 auto;">
    <div class="buttons-box" id="buttonsBox">
      <div class="w-120px">
        <a-icon @click="play" class="jessibuca-btn" type="play-circle" v-if="!playing" />
        <a-icon @click="pause" class="jessibuca-btn" type="pause-circle" v-if="playing" />
        <a-icon @click="destroy" class="jessibuca-btn" type="stop" />
        <a-icon @click="mute()" class="jessibuca-btn" theme="filled" type="audio" v-if="isNotMute" />
        <a-icon @click="cancelMute()" class="jessibuca-btn" type="audio" v-if="!isNotMute" />
      </div>
      <div class="video-name flex-1 text-center items-center" style="color:#fff">{{videoName}}</div>
      <div class="w-150px text-right">
        <span class="jessibuca-btn">{{ kBps }} kb/s</span>

        <a-icon
          @click="screenShot('截图','png',0.5)"
          class="jessibuca-btn"
          style="font-size: 1rem !important"
          type="picture"
        />
        <!-- <a-icon @click="playBtnClick" class="jessibuca-btn" type="reload" /> -->
        <!-- <a-icon @click="fullscreen" class="jessibuca-btn" type="fullscreen" v-if="!fullscreen" />
        <a-icon @click="fullscreen" class="jessibuca-btn" type="fullscreen-exit" v-if="fullscreen" />-->
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name: "DemoPlayer",
    props: {
      videoUrl: {
        type: String,
        default: ""
      },
      videoName: {
        type: String,
        default: ""
      }
    },
    data () {
      return {
        jessibuca: null,
        version: '',
        wasm: false,
        vc: "ff",
        playing: false,
        quieting: true,
        loaded: false, // mute
        showOperateBtns: false,
        showBandwidth: false,
        err: "",
        speed: 0,
        performance: "",
        volume: 1,
        rotate: 0,
        useWCS: false,
        useMSE: false,
        useOffscreen: false,
        recording: false,
        recordType: 'webm',
        scale: 0,
        kBps: 0,
        isNotMute: false
      };
    },
    computed: {
      url () {
        return this.videoUrl ?? decodeURIComponent(this.$route.params.url)
      }
    },
    created () {

    },
    mounted () {
      this.create();
      window.onerror = (msg) => (this.err = msg);
      this.$nextTick(() => {
        this.updatePlayerDomSize()

        this.play()
      })
      // this.$nextTick(() => {
      //   this.play()
      // })
      window.addEventListener('resize', this.updatePlayerDomSize)
    },
    unmounted () {
      this.jessibuca.destroy();
      this.jessibuca = null
    },
    methods: {

      updatePlayerDomSize () {

        let dom = this.$refs.container;
        let width = dom.parentNode.clientWidth
        let height = dom.parentNode.clientHeight

        const clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
        if (height > clientHeight) {
          height = clientHeight
          width = (16 / 9) * height
        } else {
          height = width * 9 / 16;
        }

        dom.style.width = width + 'px';
        dom.style.height = height + "px";
      },
      create (options) {
        options = options || {};
        this.jessibuca = new window.Jessibuca(
          Object.assign(
            {
              container: this.$refs.container,
              videoBuffer: Number('0.2'), // 缓存时长
              isResize: false,
              useWCS: this.useWCS,
              useMSE: this.useMSE,
              //   autoWasm: true,
              text: "",
              isFlv: true,
              // background: "bg.jpg",
              loadingText: "加载中...",
              hasAudio: false,
              debug: false,
              decoder: "/decoder.js",

              supportDblclickFullscreen: true,
              // showBandwidth: this.showBandwidth, // 显示网速
              operateBtns: {
                fullscreen: this.showOperateBtns,
                screenshot: this.showOperateBtns,
                play: this.showOperateBtns,
                audio: this.showOperateBtns,
              },
              // vod: this.vod,
              forceNoOffscreen: !this.useOffscreen,
              isNotMute: this.isNotMute,
              // timeout: 10
            },
            options
          )
        );
        var _this = this;
        this.jessibuca.on("load", function () {
          console.log("on load");
        });

        this.jessibuca.on("log", function (msg) {
          // console.log("on log", msg);
        });
        this.jessibuca.on("record", function (msg) {
          // console.log("on record:", msg);
        });
        this.jessibuca.on("pause", function () {
          // console.log("on pause");
          _this.playing = false;
          _this.performance = "";
        });
        this.jessibuca.on("play", function () {
          // console.log("on play");
          _this.playing = true;
        });
        this.jessibuca.on("fullscreen", function (msg) {
          // console.log("on fullscreen", msg);
        });

        this.jessibuca.on("mute", function (msg) {
          // console.log("on mute", msg);
          _this.quieting = msg;
          _this.isNotMute = !msg;

        });



        this.jessibuca.on("audioInfo", function (msg) {
          // console.log("audioInfo", msg);
        });

        // this.jessibuca.on("bps", function (bps) {
        //   // console.log('bps', bps);
        // });
        // let _ts = 0;
        // this.jessibuca.on("timeUpdate", function (ts) {
        //     console.log('timeUpdate,old,new,timestamp', _ts, ts, ts - _ts);
        //     _ts = ts;
        // });

        this.jessibuca.on("videoInfo", function (info) {
          // console.log("videoInfo", info);
        });

        this.jessibuca.on("error", function (error) {
          // console.log("error", error);
        });

        this.jessibuca.on("timeout", function () {
          // console.log("timeout");
        });

        this.jessibuca.on('start', function () {
          // console.log('frame start');
        })

        this.jessibuca.on("performance", function (performance) {
          var show = "卡顿";
          if (performance === 2) {
            show = "非常流畅";
          } else if (performance === 1) {
            show = "流畅";
          }
          _this.performance = show;
        });
        this.jessibuca.on('buffer', function (buffer) {
          // console.log('buffer', buffer);
        })

        this.jessibuca.on('stats', function (stats) {
          // console.log('stats', stats);
        })

        this.jessibuca.on('kBps', function (kBps) {
          // console.log('kBps', kBps);
          _this.kBps = kBps
        });

        this.jessibuca.on("play", () => {
          this.playing = true;
          this.loaded = true;
          this.quieting = this.jessibuca.isMute();
        });

        this.jessibuca.on('recordingTimestamp', (ts) => {
          // console.log('recordingTimestamp', ts);
        })


        // console.log(this.jessibuca);
      },
      play () {

        // this.jessibuca.onPlay = () => (this.playing = true);
        // const url = 'http://81.70.11.184:80/rtp/34020000001110001513_34020000001320000001.live.flv'

        this.jessibuca.play(this.url);

        // restartPlay('mse')

      },
      mute () {
        this.jessibuca.mute();
      },
      cancelMute () {
        this.jessibuca.cancelMute();
      },

      pause () {
        this.jessibuca.pause();
        this.playing = false;
        this.err = "";
        this.performance = "";
      },
      volumeChange () {
        this.jessibuca.setVolume(this.volume);
      },
      rotateChange () {
        this.jessibuca.setRotate(this.rotate);
      },
      destroy () {

        if (this.jessibuca) {
          this.jessibuca.destroy();
        }
        this.create();
        this.playing = false;
        this.loaded = false;
        this.performance = "";
      },

      fullscreen () {
        this.jessibuca.setFullscreen(true);
      },

      clearView () {
        this.jessibuca.clearView();
      },

      startRecord () {
        const time = new Date().getTime();
        this.jessibuca.startRecord(time, this.recordType);
      },

      stopAndSaveRecord () {
        this.jessibuca.stopRecordAndSave();
      },


      screenShot () {
        this.jessibuca.screenshot('截图', 'png', 0.5);
      },


      restartPlay (type) {

        if (type === 'mse') {
          this.useWCS = false;
          this.useOffscreen = false;
        } else if (type === 'wcs') {
          this.useMSE = false
        } else if (type === 'offscreen') {
          this.useMSE = false
        }

        this.destroy();
        setTimeout(() => {
          this.play();
        }, 100)
      },

      changeBuffer () {
        this.jessibuca.setBufferTime(Number(this.$refs.buffer.value));
      },

      scaleChange () {
        this.jessibuca.setScaleMode(this.scale);
      },
    },
    destroyed () {
      window.removeEventListener('resize', this.updatePlayerDomSize)

      if (this.jessibuca) {
        this.pause()
        this.jessibuca.destroy();


        this.playing = false;
        this.loaded = false;
        this.performance = "";
      }
      this.jessibuca = null
    }
  };
</script>
<style>

  .buttons-box {
    width: 100%;
    height: 28px;
    background-color: rgba(43, 51, 63, 0.7);
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    left: 0;
    bottom: 0;
    user-select: none;
    z-index: 1;
  }

  .jessibuca-btn {
    /* width: 20px; */
    color: rgb(255, 255, 255);
    line-height: 27px;
    margin: 0px 10px;
    padding: 0px 2px;
    cursor: pointer;
    text-align: center;
    font-size: 0.8rem !important;
  }

</style>